import { Component, OnInit, ViewChild } from '@angular/core';
import { MatInput } from '@angular/material';
import { DatePipe } from '@angular/common';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { DashboardService } from '../dashboard.service';
import { ToastrService } from 'ngx-toastr';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { Angular5Csv } from 'angular5-csv/dist/Angular5-csv';

@Component({
  selector: 'app-wms-error-log',
  templateUrl: './wms-error-log.component.html',
  styleUrls: ['./wms-error-log.component.scss']
})

export class WmsErrorLogComponent implements OnInit {
  @ViewChild('input', { read: MatInput, static: false }) input: MatInput
  @ViewChild('input1', { read: MatInput, static: false }) input1: MatInput
  @ViewChild('input2', { read: MatInput, static: false }) input2: MatInput
  @ViewChild('input3', { read: MatInput, static: false }) input3: MatInput

  private ResponseVerifiedClearAlaramsNormalUser$: Subject<any> = new Subject();
  private ResponseVerifiedUnclearAlaramsNormalUser$: Subject<any> = new Subject();

  pipe = new DatePipe('en-US')
  public ClearedAlaramsform: FormGroup;
  public UnClearedAlaramsform: FormGroup;
  public minDate = new Date();
  role: any;
  user_Id: any;
  roleName: string;
  showAlarmsTab: string;
  limit = 10;
  clearAlaramsOffset = 0;
  unclearAlaramsOffset = 0;
  page = 1;
  page1 = 1;
  UnClearedAlaramsReqObject: { user_id: any; start_date: string; end_date: string; limit: number; offset: any; };
  unClearedAlaramsDetails: any[];

  unClearedAlaramsCSVDetails:any[];
  unClearAlramsCount: number;
  clearAlramsCount: number;
  ClearedAlaramsDetails: any[];
  ClearedAlaramsReqObject: { user_id: any; start_date: string; end_date: string; limit: number; offset: any; };
  formula: string = "Download_CSV";

  constructor(private fb: FormBuilder, private router: Router, private dashboardService: DashboardService,
    private toastr: ToastrService) {

    this.role = localStorage.role;
    this.user_Id = localStorage.id;
    if (this.role == '1') {
      this.roleName = 'admin';
    } else if (this.role == '2') {
      this.roleName = 'epc';
    } else if (this.role == '3') {
      this.roleName = 'wms';
    } else if (this.role == '4') {
      this.roleName = 'normal';
    } else if (this.role == '6') {
    this.roleName = 'ze';
  }else if (this.role == '7') {
    this.roleName = 'dg';
  }
  }

  ngOnInit() {
    this.ClearedAlaramsform = this.fb.group({
      clearEnd_dt: ['', Validators.required],
      clearStart_dt: ['', Validators.required]
    });

    this.UnClearedAlaramsform = this.fb.group({
      unclearStart_dt: ['', Validators.required],
      unclearEnd_dt: ['', Validators.required]
    });
    if (this.roleName == 'wms') {
      this.showAlarmsTab = 'UnClearedAlarmsTab';

      this.getUnClearedAlarams(0);
    }
  }

  showClearedAlarmsTab(tab) {
    this.showAlarmsTab = tab;
    this.clearAlaramsOffset=0;
    this.getClearedAlarams(this.clearAlaramsOffset);
    this.resetUnClearedAlarams()

  }
  showUnClearedAlarmsTab(tab) {
    this.showAlarmsTab = tab;
    this.unclearAlaramsOffset=0;
    this.getUnClearedAlarams(this.unclearAlaramsOffset);
     this.resetClearedAlarams();
  }
  // reset value ClearedAlarams For Normal User
  public resetClearedAlarams() {
    this.ClearedAlaramsform.controls.clearStart_dt.setValue('');
    this.ClearedAlaramsform.controls.clearEnd_dt.setValue('');
    this.ClearedAlaramsform.reset();
    this.clearAlaramsOffset=0;
    this.getClearedAlarams(this.clearAlaramsOffset);

  }
  // reset value UnClearedAlarams For Normal User
  public resetUnClearedAlarams() {
    this.UnClearedAlaramsform.controls.unclearStart_dt.setValue('');
    this.UnClearedAlaramsform.controls.unclearEnd_dt.setValue('');
    this.UnClearedAlaramsform.reset();
    this.unclearAlaramsOffset=0;
    this.getUnClearedAlarams(this.unclearAlaramsOffset);

  }
  // get UnClearedAlarams for Normal User
  getUnClearedAlarams(offset) {
    if (offset == 0) {   //for Nevigte first page
      this.page1 = 1
    }

    this.UnClearedAlaramsReqObject = {
      user_id: this.user_Id,
      start_date: this.pipe.transform(this.UnClearedAlaramsform.controls['unclearStart_dt'].value, "yyyy-MM-dd"),
      end_date: this.pipe.transform(this.UnClearedAlaramsform.controls['unclearEnd_dt'].value, "yyyy-MM-dd"),
      limit: this.limit,
      offset: offset
    }

    this.dashboardService.getNormalUserUnClearedAlarms(this.UnClearedAlaramsReqObject)
      .pipe(takeUntil(this.ResponseVerifiedUnclearAlaramsNormalUser$))
      .subscribe(
        async result => {
          this.unClearAlramsCount = 0;
          this.unClearedAlaramsDetails = [];
          if (result.status) {
            this.unClearAlramsCount = result.count;
            this.unClearedAlaramsDetails = result.resultObject;
          } else if (!result.status) {
            if (result.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(["/login"]);
            } else {
              this.toastr.info(result.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }
  // get ClearedAlarams for Normal User
  getClearedAlarams(offset) {
    if (offset == 0) {   //for Nevigte first page
      this.page = 1
    }
    this.ClearedAlaramsReqObject = {
      user_id: this.user_Id,
      start_date: this.pipe.transform(this.ClearedAlaramsform.controls['clearEnd_dt'].value, "yyyy-MM-dd"),
      end_date: this.pipe.transform(this.ClearedAlaramsform.controls['clearEnd_dt'].value, "yyyy-MM-dd"),
      limit: this.limit,
      offset: offset
    }
    this.dashboardService.getNormalUserClearedAlarms(this.ClearedAlaramsReqObject)
      .pipe(takeUntil(this.ResponseVerifiedClearAlaramsNormalUser$))
      .subscribe(
        async result => {
          this.clearAlramsCount = 0;
          this.ClearedAlaramsDetails = [];
          if (result.status) {
            this.clearAlramsCount = result.count;
            this.ClearedAlaramsDetails = result.resultObject;
          } else if (!result.status) {
            if (result.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(["/login"]);
            } else {
              this.toastr.info(result.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }
  // download csv of cleared alarm
  downloadCSVClearedAlarams(){
    this.UnClearedAlaramsReqObject = {
      user_id: this.user_Id,
      start_date: this.pipe.transform(this.UnClearedAlaramsform.controls['unclearStart_dt'].value, "yyyy-MM-dd"),
      end_date: this.pipe.transform(this.UnClearedAlaramsform.controls['unclearEnd_dt'].value, "yyyy-MM-dd"),
      limit: 0,
      offset: '0'
    }

    this.dashboardService.getNormalUserClearedAlarms(this.UnClearedAlaramsReqObject)
      .pipe(takeUntil(this.ResponseVerifiedUnclearAlaramsNormalUser$))
      .subscribe(
        async result => {
          this.unClearedAlaramsCSVDetails = [];
          if (result.status) {
            this.unClearedAlaramsCSVDetails = result.resultObject;
            var data = this.unClearedAlaramsCSVDetails;
            var options = {
              title: 'Cleared Alarms',
              fieldSeparator: ',',
              quoteStrings: '"',
              decimalseparator: '.',
              showLabels: true,
              showTitle: true,
              useBom: true,
              headers: ['Device Name', ' Name', 'Inverter Name', 'Alarm Id', 'Occurance Time','Clearance Time ', 'Alarm Message']
            };
            new Angular5Csv(data, this.formula, options);
          } else if (!result.status) {
            if (result.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(["/login"]);
            } else {
              this.toastr.info(result.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }



  //download uncleared alarm csv

  downloadCSVUnClearedAlarams(){
    this.UnClearedAlaramsReqObject = {
      user_id: this.user_Id,
      start_date: this.pipe.transform(this.UnClearedAlaramsform.controls['unclearStart_dt'].value, "yyyy-MM-dd"),
      end_date: this.pipe.transform(this.UnClearedAlaramsform.controls['unclearEnd_dt'].value, "yyyy-MM-dd"),
      limit: 0,
      offset: '0'
    }
    this.dashboardService.getNormalUserUnClearedAlarms(this.UnClearedAlaramsReqObject)
      .pipe(takeUntil(this.ResponseVerifiedUnclearAlaramsNormalUser$))
      .subscribe(
        async result => {
          this.unClearedAlaramsCSVDetails = [];
          if (result.status) {
           this.unClearedAlaramsDetails = result.resultObject;
           var data = this.unClearedAlaramsDetails;
           var options = {
             title: 'Un-Cleared Alarms',
             fieldSeparator: ',',
             quoteStrings: '"',
             decimalseparator: '.',
             showLabels: true,
             showTitle: true,
             useBom: true,
             headers: ['Device Name', 'Name', 'Inverter Name', 'Alarm Id', 'Occurance Time',  'Alarm Message']
           };
           new Angular5Csv(data, this.formula, options);
          } else if (!result.status) {
            if (result.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(["/login"]);
            } else {
              this.toastr.info(result.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }

  //pagination for Unclear alarm for normal user
  nextPageUnclearAlarm(pageIndex): void {
    this.unclearAlaramsOffset = (pageIndex - 1) * 10;
    this.getUnClearedAlarams(this.unclearAlaramsOffset);
  }
  //pagination for ClearAlarm alarm for normal user
  nextPageClearAlarm(pageIndex): void {
    this.clearAlaramsOffset = (pageIndex - 1) * 10;
    this.getClearedAlarams(this.clearAlaramsOffset);
  }
  ngOnDestroy() {
    this.ResponseVerifiedClearAlaramsNormalUser$.next();
    this.ResponseVerifiedClearAlaramsNormalUser$.complete();

    this.ResponseVerifiedUnclearAlaramsNormalUser$.next();
    this.ResponseVerifiedUnclearAlaramsNormalUser$.complete()
  }
}
